import VLApi from "@/api/VLApi";
import { useWebportalStore } from "@/stores/webportal";

// function to compare version numbers
const compare = (a: string, b: string) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base'})
// function to get the latest compatible version
const maxVersion = (v: string[], t: string) => v.sort(compare).reduce((a, b) => compare(t, b) < 0 ? a : b, v.sort(compare)[0])

export default async function checkVersion() {
    const baseTest = window.location.pathname.match(/(.*\/)/);
    let base = baseTest ? baseTest[1] : '/';
    const versionIndex = base.indexOf("version");
    if (versionIndex > -1) {
        base = base.substring(0, versionIndex);
    }

    // get all available app versions
    const appVersions = (await fetch(`${base}appVersions.json`).then(r => r.ok ? r.json() : null).catch(e => console.info(e)));
    if (!appVersions) {
        return;
    }
    // get current vl api version, 
    const vlApiVersion = await VLApi.get(`${useWebportalStore().vlApiUrl}/ApiVersion`).then(r => r.data.data.trim());
    // get latest compatible version
    let version = maxVersion(appVersions, vlApiVersion);

    let target = `${base}version/${version}/index.html`;

    // if latest version go to root page
    if (compare(vlApiVersion, appVersions.sort(compare).slice(-1)[0]) >= 0) {
        version = 'latest'
        target = base;
    }

    if (window.location.pathname != target) {
        window.location.pathname = target;
    }
    
    window.localStorage.setItem("vlApiVersion", vlApiVersion)
    window.localStorage.setItem("version", version)
    
    useWebportalStore().vlApiVersion = vlApiVersion
    useWebportalStore().version = version
}